export type ThemeMode = 'device' | 'light' | 'dark';

const KEY = 'theme-mode';

/** The saved choice, or the device's own when nothing is saved or storage is blocked. */
export function readThemeMode(): ThemeMode {
  try {
    const saved = window.localStorage.getItem(KEY);
    if (saved === 'light' || saved === 'dark' || saved === 'device') return saved;
  } catch {
    // Storage can be blocked: the device setting applies.
  }
  return 'device';
}

export function saveThemeMode(mode: ThemeMode): void {
  try {
    if (mode === 'device') window.localStorage.removeItem(KEY);
    else window.localStorage.setItem(KEY, mode);
  } catch {
    // Not saved: the choice still holds until the page is closed.
  }
}

/** `device` removes the override so the stylesheet follows the phone's setting. */
export function applyThemeMode(
  mode: ThemeMode,
  root: HTMLElement = document.documentElement,
): void {
  if (mode === 'device') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', mode);
}
